import filterFunc from './iso3166-to-country-name.filter';

const mod = angular.module('iso3166Filter', []);

mod.filter('iso3166ToCountryName', function () {
  return filterFunc;
});

export default mod;
